'use client';
import React, { FC } from 'react';

export const LoadingIndicator: FC = () => (
  <div className="minthr-loading-spinner-container ">
    <img
      className="minthr-loading-spinner minthr-icon-s"
      src="/icons/spinner-outer.svg"
      alt="spinner"
    />
  </div>
);
